import { render, staticRenderFns } from "./Quicknavigation.vue?vue&type=template&id=72fa5d74&scoped=true&"
import script from "./Quicknavigation.vue?vue&type=script&lang=js&"
export * from "./Quicknavigation.vue?vue&type=script&lang=js&"
import style0 from "./Quicknavigation.vue?vue&type=style&index=0&id=72fa5d74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fa5d74",
  null
  
)

export default component.exports